export default __webpack_public_path__ + "static/media/featured_products_ads.684e1705.jpg";